
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { DebtCollectionReadyInvoicesDtoModel } from 'models/generated/Accounting.Api.Models.DebtCollectionReadyInvoicesDto';
import { AccountingCompanyStatusModel } from 'models/generated/Accounting.Api.Models.AccountingCompanyStatus';
import { InstallmentPaymentModel } from 'models/generated/Entities.Accounting.InstallmentPayment';


const _accounting_AccountingControllerHelper = new Map<string, Object>();
_accounting_AccountingControllerHelper.set('GetInvoicesReadyForDebtCollection', DebtCollectionReadyInvoicesDtoModel);
_accounting_AccountingControllerHelper.set('CompaniesStatuses', AccountingCompanyStatusModel);
_accounting_AccountingControllerHelper.set('GetInstallmentPaymentsForDocuments', InstallmentPaymentModel);


export const accounting_AccountingControllerHelper = _accounting_AccountingControllerHelper;

